import type { TaskColor, TaskUrgency } from '@obras/shared';
import { ArrowDown, ChevronsUp, TriangleAlert, type LucideIcon } from 'lucide-react';

/**
 * Classes da paleta de etiqueta.
 *
 * O mapa é explícito porque o Tailwind lê as classes no código-fonte: montar
 * `bg-flag-${cor}` em tempo de execução geraria um nome que o gerador nunca
 * viu, e a cor sairia sem folha de estilo.
 */
export const FLAG_BG: Record<TaskColor, string> = {
  laranja: 'bg-flag-laranja',
  ambar: 'bg-flag-ambar',
  verde: 'bg-flag-verde',
  azul: 'bg-flag-azul',
  roxo: 'bg-flag-roxo',
  rosa: 'bg-flag-rosa',
};

export const FLAG_TEXT: Record<TaskColor, string> = {
  laranja: 'text-flag-laranja',
  ambar: 'text-flag-ambar',
  verde: 'text-flag-verde',
  azul: 'text-flag-azul',
  roxo: 'text-flag-roxo',
  rosa: 'text-flag-rosa',
};

/**
 * Como cada urgência aparece.
 *
 * `normal` não tem entrada: tarefa normal não ganha etiqueta, senão a exceção
 * se perde no meio do que é rotina.
 */
export const URGENCY_STYLE: Record<
  Exclude<TaskUrgency, 'normal'>,
  { icon: LucideIcon; className: string }
> = {
  baixa: { icon: ArrowDown, className: 'text-muted-foreground' },
  alta: { icon: ChevronsUp, className: 'text-warning' },
  urgente: { icon: TriangleAlert, className: 'text-danger' },
};

export const isSignalledUrgency = (
  urgency: TaskUrgency,
): urgency is Exclude<TaskUrgency, 'normal'> => urgency !== 'normal';
